/**
 * 内部ドメイン判定ユーティリティ
 *
 * @sekitori/core と同じロジックをフロントエンド用にローカル定義。
 * core のバレルファイルは node:crypto を含むエンティティを re-export するため、
 * Vite ブラウザビルドで直接 import できない。
 */
export const INTERNAL_DOMAIN = "mediowl.co.jp";

export function isInternalUser(email: string): boolean {
  const atIndex = email.lastIndexOf("@");
  if (atIndex === -1) {
    return false;
  }
  const domain = email.slice(atIndex + 1);
  return domain === INTERNAL_DOMAIN;
}
